import { useState } from "react";
import styles from "./chatBotApiTest.module.css";

export const CartPanel = ({ loading, onSubmit }) => {
  const [sku, setSku] = useState("ABC10");
  const [qty, setQty] = useState("1");
  const [hint, setHint] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!sku.trim()) {
      setHint("Enter a SKU.");
      return;
    }

    if (!Number.isInteger(Number(qty)) || Number(qty) < 1) {
      setHint("Quantity must be a whole number of 1 or more.");
      return;
    }

    setHint("");
    onSubmit(sku.trim(), Number(qty));
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <label className={styles.field}>
        <span>SKU</span>
        <input value={sku} onChange={(event) => setSku(event.target.value)} placeholder="ABC10" />
      </label>

      <label className={styles.field}>
        <span>Quantity</span>
        <input value={qty} onChange={(event) => setQty(event.target.value)} inputMode="numeric" placeholder="1" />
      </label>

      <p className={styles.note}>Quantity is an increment: sending 4 twice leaves the line at 8. Max 999 per call.</p>

      {hint ? <p className={styles.hint}>{hint}</p> : null}

      <button type="submit" className={styles.primaryButton} disabled={loading}>
        {loading ? "Sending…" : "Send request"}
      </button>
    </form>
  );
};
